export type DiffStatus = 'MATCHED' | 'QUANTITY_CHANGED' | 'REMOVED' | 'NET_NEW';
export type ComparisonRow = {
  pplId: string;
  status: DiffStatus;
  orderedQty?: number;
  packedQty?: number;
};

export function computePackingListDiff(
  orderItems: Array<{
    platformProductsLengths: { id: string };
    quantity: { value: number };
  }>,
  packedItems: Array<{
    platformProductsLengths: { id: string };
    quantity: { value: number };
  }>
): ComparisonRow[] {
  const orderMap = new Map(
    orderItems.map((i) => [i.platformProductsLengths.id, i])
  );
  const packMap = new Map(
    packedItems.map((i) => [i.platformProductsLengths.id, i])
  );

  const changedAndRemoved: ComparisonRow[] = [];
  const matched: ComparisonRow[] = [];
  const netNew: ComparisonRow[] = [];

  // Pass 1: QUANTITY_CHANGED and REMOVED (items in order)
  for (const [pplId, orderItem] of orderMap) {
    const packItem = packMap.get(pplId);
    if (!packItem) {
      changedAndRemoved.push({
        pplId,
        status: 'REMOVED',
        orderedQty: orderItem.quantity.value,
      });
    } else if (orderItem.quantity.value !== packItem.quantity.value) {
      changedAndRemoved.push({
        pplId,
        status: 'QUANTITY_CHANGED',
        orderedQty: orderItem.quantity.value,
        packedQty: packItem.quantity.value,
      });
    }
  }

  // Pass 2: MATCHED
  for (const [pplId, orderItem] of orderMap) {
    const packItem = packMap.get(pplId);
    if (packItem && orderItem.quantity.value === packItem.quantity.value) {
      matched.push({
        pplId,
        status: 'MATCHED',
        orderedQty: orderItem.quantity.value,
        packedQty: packItem.quantity.value,
      });
    }
  }

  // Pass 3: NET_NEW (in pack, not in order)
  for (const [pplId, packItem] of packMap) {
    if (!orderMap.has(pplId)) {
      netNew.push({
        pplId,
        status: 'NET_NEW',
        packedQty: packItem.quantity.value,
      });
    }
  }

  return [...changedAndRemoved, ...matched, ...netNew];
}

export const DIFF_BADGE: Record<
  DiffStatus,
  { label: string; className: string }
> = {
  MATCHED: {
    label: 'Matched',
    className: 'bg-green-100 text-green-700',
  },
  QUANTITY_CHANGED: {
    label: 'Qty Changed',
    className: 'bg-amber-100 text-amber-700',
  },
  REMOVED: {
    label: 'Removed',
    className: 'bg-red-100 text-red-700',
  },
  NET_NEW: {
    label: 'Net New',
    className: 'bg-blue-100 text-blue-700',
  },
};
